import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';

export default function OptionSkeleton() {
  return (
    <Stack
      aria-label="dashboard-not-fund-options-skeleton"
      gap={{ xs: '16px', md: '24px' }}
    >
      {Array.from({ length: 4 }, (_, key) => (
        <Skeleton
          height={114}
          key={key}
          width="100%"
        />
      ))}
    </Stack>
  );
}
